import { defaultTimeZone, defaultLocales } from './constants';

/**
 * Converts a Date object into a month and day string formatted numerically.
 *
 * e.g. Thursday
 * @param {Date} date a Date object you want to convert into a string
 * @param {object} options -
 * @param {string} options.timeZone - the timezone you want date displayed in, defaults to current users time zone
 * @returns {string} a formatted date string
 */
export const dayOfWeekString = (
  date: Date | null,
  { timeZone = defaultTimeZone }: DateOnlyStringOptions = {},
): string => {
  if (date === null) {
    return '';
  }

  try {
    return new Intl.DateTimeFormat(defaultLocales, {
      weekday: 'long',
      timeZone,
    }).format(date);
  } catch (error: unknown) {
    console.error(error); // eslint-disable-line no-console
    return ''; // handle bad input
  }
};
